var map = {
	"./da-DK": [
		880,
		0,
		6
	],
	"./da-DK.ts": [
		880,
		0,
		6
	],
	"./de-DE": [
		881,
		0,
		7
	],
	"./de-DE.ts": [
		881,
		0,
		7
	],
	"./en-AU": [
		882,
		0,
		8
	],
	"./en-AU.ts": [
		882,
		0,
		8
	],
	"./en-GB": [
		883,
		0,
		9
	],
	"./en-GB.ts": [
		883,
		0,
		9
	],
	"./en-US": [
		884,
		0,
		10
	],
	"./en-US.ts": [
		884,
		0,
		10
	],
	"./es-ES": [
		885,
		0,
		11
	],
	"./es-ES.ts": [
		885,
		0,
		11
	],
	"./fr-FR": [
		886,
		0,
		12
	],
	"./fr-FR.ts": [
		886,
		0,
		12
	],
	"./it-IT": [
		887,
		0,
		13
	],
	"./it-IT.ts": [
		887,
		0,
		13
	],
	"./nb-NO": [
		888,
		0,
		14
	],
	"./nb-NO.ts": [
		888,
		0,
		14
	],
	"./nl-NL": [
		889,
		0,
		15
	],
	"./nl-NL.ts": [
		889,
		0,
		15
	],
	"./pl-PL": [
		890,
		0,
		16
	],
	"./pl-PL.ts": [
		890,
		0,
		16
	],
	"./pt-PT": [
		891,
		0,
		17
	],
	"./pt-PT.ts": [
		891,
		0,
		17
	],
	"./sv-SE": [
		892,
		0,
		18
	],
	"./sv-SE.ts": [
		892,
		0,
		18
	],
	"./tr-TR": [
		893,
		0,
		19
	],
	"./tr-TR.ts": [
		893,
		0,
		19
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 1828;
module.exports = webpackAsyncContext;